import React from "react";
import { MessageCircle, Mail } from "lucide-react";
import { CONTACT } from "../lib/data";

export const FloatingContact = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      <a
        data-testid="float-whatsapp"
        href={`https://wa.me/${CONTACT.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_0_25px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-110"
      >
        <MessageCircle size={26} />
      </a>
      <a
        data-testid="float-email"
        href={`mailto:${CONTACT.email}`}
        aria-label="Email"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-gold text-black shadow-[0_0_25px_rgba(212,175,55,0.35)] transition-transform duration-300 hover:scale-110"
      >
        <Mail size={24} />
      </a>
    </div>
  );
};
